import { render, staticRenderFns } from "./IschromeIOS.vue?vue&type=template&id=cc2fd2a2&"
import script from "./IschromeIOS.vue?vue&type=script&lang=js&"
export * from "./IschromeIOS.vue?vue&type=script&lang=js&"
import style0 from "./IschromeIOS.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IschromeIOS.vue"
export default component.exports